export default {
    de: {
        mm_yyyy_placeholder: 'MM.JJJJ',
        dd_mm_yyyy_placeholder: 'TT.MM.JJJJ',
    },
};
